var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "page-outline",
    {
      attrs: {
        title: _vm.$t("common.security.title"),
        "show-refresh": true,
        "refresh-disabled": _vm.activateSpinner,
      },
      on: { refresh: _vm.onRefresh },
    },
    [
      _c("template", { slot: "navigationTabs" }, [
        _c("div", { staticClass: "d-block d-lg-none" }, [
          _c(
            "div",
            { staticClass: "d-flex flex-column" },
            [
              _c("app-button", {
                attrs: {
                  text: _vm.$t("common.security.trust_store"),
                  variant: _vm.tabName === 0 ? "primary" : "light",
                  size: "md",
                  block: true,
                  "custom-class": "mb-2",
                  "aria-pressed": _vm.tabName === 0 ? "true" : "false",
                },
                on: {
                  click: function ($event) {
                    _vm.tabName = 0
                  },
                },
              }),
              _vm._v(" "),
              _c("app-button", {
                attrs: {
                  text: _vm.$t("common.security.key_store"),
                  variant: _vm.tabName === 1 ? "primary" : "light",
                  size: "md",
                  block: true,
                  "custom-class": "mb-2",
                  "aria-pressed": _vm.tabName === 1 ? "true" : "false",
                },
                on: {
                  click: function ($event) {
                    _vm.tabName = 1
                  },
                },
              }),
            ],
            1
          ),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "d-none d-lg-block" },
          [
            _c(
              "b-nav",
              { staticClass: "border-0", attrs: { tabs: "", fill: "" } },
              [
                _c(
                  "b-nav-item",
                  {
                    class: { "bg-primary text-white": _vm.tabName === 0 },
                    attrs: { active: _vm.tabName === 0 },
                    on: {
                      click: function ($event) {
                        _vm.tabName = 0
                      },
                    },
                  },
                  [
                    _c(
                      "span",
                      { class: { "font-weight-bold": _vm.tabName === 0 } },
                      [
                        _vm._v(
                          "\n              " +
                            _vm._s(_vm.$t("common.security.trust_store")) +
                            "\n            "
                        ),
                      ]
                    ),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "b-nav-item",
                  {
                    class: { "bg-primary text-white": _vm.tabName === 1 },
                    attrs: { active: _vm.tabName === 1 },
                    on: {
                      click: function ($event) {
                        _vm.tabName = 1
                      },
                    },
                  },
                  [
                    _c(
                      "span",
                      { class: { "font-weight-bold": _vm.tabName === 1 } },
                      [
                        _vm._v(
                          "\n              " +
                            _vm._s(_vm.$t("common.security.key_store")) +
                            "\n            "
                        ),
                      ]
                    ),
                  ]
                ),
              ],
              1
            ),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c(
        "template",
        { slot: "secondaryActions" },
        [
          _c("app-button", {
            attrs: {
              text:
                _vm.tabName === 0
                  ? _vm.$t("common.security.add_p12", {
                      itemLabel: "truststore",
                    })
                  : _vm.$t("common.security.add_p12", {
                      itemLabel: "keystore",
                    }),
              icon: "fa-light fa-plus",
              variant: "light",
              "responsive-layout": true,
              disabled: !_vm.canAdd,
            },
            on: { click: _vm.addP12 },
          }),
          _vm._v(" "),
          _c("app-button", {
            attrs: {
              text:
                _vm.tabName === 0
                  ? _vm.$t("common.security.add_pem", {
                      itemLabel: "truststore",
                    })
                  : _vm.$t("common.security.add_pem", {
                      itemLabel: "keystore",
                    }),
              icon: "fa-light fa-plus",
              variant: "light",
              "responsive-layout": true,
              disabled: !_vm.canAdd,
            },
            on: { click: _vm.addPEM },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c("template", { slot: "pageContent" }, [
        _c(
          "div",
          { staticClass: "listPage ml-3 mr-3" },
          [
            _c(
              "b-tabs",
              {
                attrs: { "nav-class": "d-none" },
                model: {
                  value: _vm.tabName,
                  callback: function ($$v) {
                    _vm.tabName = $$v
                  },
                  expression: "tabName",
                },
              },
              [
                _vm.canSeeCA
                  ? _c(
                      "b-tab",
                      { attrs: { title: _vm.$t("common.security.ca") } },
                      [
                        _c("security-list", {
                          key: _vm.refreshKey,
                          attrs: {
                            typeList: "ca",
                            spinnerActivated: _vm.activateSpinner,
                          },
                          model: {
                            value: _vm.tabValue,
                            callback: function ($$v) {
                              _vm.tabValue = $$v
                            },
                            expression: "tabValue",
                          },
                        }),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.canSeeKeyStore
                  ? _c(
                      "b-tab",
                      { attrs: { title: _vm.$t("common.security.keystore") } },
                      [
                        _c("security-list", {
                          key: _vm.refreshKey,
                          attrs: {
                            typeList: "keystore",
                            spinnerActivated: _vm.activateSpinner,
                          },
                          model: {
                            value: _vm.tabValue,
                            callback: function ($$v) {
                              _vm.tabValue = $$v
                            },
                            expression: "tabValue",
                          },
                        }),
                      ],
                      1
                    )
                  : _vm._e(),
              ],
              1
            ),
          ],
          1
        ),
      ]),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }